export default __webpack_public_path__ + "static/media/andes_a_la_costa_5.05ccf660.JPG";